var map = {
	"./js0/2.png": "7c9e",
	"./js1/2.png": "b3c0",
	"./js2/2.png": "8bb7",
	"./js3/2.png": "2518",
	"./js4/2.png": "f860",
	"./js5/2.png": "2f80",
	"./js6/2.png": "9aa2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a06b";